'use client';

import { atom } from 'jotai';

export const hasSetCookiesAtom = atom(false);
